
import { Outlet } from 'react-router-dom'
import React from 'react'

const MyActivity = () => {
  return (
    <Outlet/>
  )
}

export default MyActivity